import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Home from './Home';
import Rsvp from './Rsvp';
import Photos from './Photos';
import { Router, Route, browserHistory } from 'react-router'
import './index.css';
import injectTapEventPlugin from 'react-tap-event-plugin';

injectTapEventPlugin();

ReactDOM.render(
  <Router history={browserHistory}>
    <Route component={App}>
      <Route path='/' component={Home} />
      <Route path='/rsvp' component={Rsvp} />
      <Route path='/photos' component={Photos} />
    </Route>
  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js